import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { configureChains, createConfig, WagmiConfig } from 'wagmi';
// import type { Chain } from "wagmi";
// import * as wagmiChains from "wagmi/chains";
import { bsc } from "wagmi/chains";
import { publicProvider } from "wagmi/providers/public";
// import { InjectedConnector } from "@wagmi/connectors/injected";
import { Web3Modal } from '@web3modal/react';
import { EthereumClient, w3mConnectors, w3mProvider } from '@web3modal/ethereum'

import { store } from './store/store';
// import { basename, production } from './settings';

// import UI from './components/UI/Test/UI.test';
import App from './components/App/App';
import WagmiWrapper from './components/utilComponents/WagmiWrapper/WagmiWrapper';
import ModalsController from './components/modals/ModalsController/ModalsController';
import EscapeHandler from './components/utilComponents/EscapeHandler/EscapeHandler';
import PingPage from './components/PingPage/PingPage';

import './scss/index.scss';


const chains = [bsc];
const projectId = '1dd4fbc33f393ff31d96077f860275cb';

const { webSocketPublicClient } = configureChains([...chains], [publicProvider()]);
const { publicClient } = configureChains(chains, [w3mProvider({ projectId })])

const config = createConfig({
	// Connectors here are needed for auto connect to work
	connectors: w3mConnectors({ projectId, chains }),
	autoConnect: true,
	publicClient,
	webSocketPublicClient,
});
const ethereumClient = new EthereumClient(config, chains)


const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
	// <React.StrictMode>
	<>
        <WagmiConfig config={config}>
			<Provider store={store}>
				<BrowserRouter basename='/dapp/'>
					<Switch>
						<Route exact path='/ping' component={PingPage}/>

						<Route>
							<EscapeHandler/>
							<WagmiWrapper/>
							<App/>
							<ModalsController/>
						</Route>
					</Switch>
				</BrowserRouter>
			</Provider>
		</WagmiConfig>

		<Web3Modal projectId={projectId} ethereumClient={ethereumClient} />

		{/* <Provider store={store}>
			<BrowserRouter basename={basename}>
				
				<Switch>
					{!production &&
						// <>	// not working
							<Route exact path='/ui-test' component={UI}/>
						// </Switch>
					}
					<Route>
						<EscapeHandler/>
						<WagmiWrapper/>
						<App/>
						<ModalsController/>
					</Route>
				</Switch>
			</BrowserRouter>
		</Provider> */}
	</>
	// </React.StrictMode>
);